/* ★ PADAM MODULE (admin) — 17 Okt 2026, arahan user ("buat 1 button").
 *
 * Satu module = doc `modules/{id}` + subkoleksi PETI BESI `modules/{id}/private/*` (`prompt` = master prompt,
 * `history_*` = versi lama). Doc utama sahaja dipadam → resepi prompt tertinggal yatim dalam peti besi,
 * jadi subkoleksi dipadam DAHULU, kemudian doc utama. (Firestore tidak memadam subkoleksi sendiri.)
 * Rules: `modules/{id}` + `private/{docId}` = tulis admin sahaja (firestore.rules) — bukan admin = ditolak server.
 *
 * ⛔ PAGAR (diputuskan 17 Okt — pelanggan berbayar tidak boleh terjejas oleh satu klik silap):
 *   • module ASAS dalam kod (config/modules.js MODULES: ai8saat · ai16saat-half · homeniche · goyang · smartcustom)
 *     → tidak boleh dipadam (doc Firestore mereka memegang master prompt module hidup).
 *   • module yang DIBUKA kepada pelanggan (`adminOnly` bukan true, cth FLOWNITY) → tidak boleh dipadam dari sini.
 *   Hanya module "Admin only" (ujian admin) boleh dipadam.
 * Tidak disentuh: card sedia ada yang memakai module itu (ia jatuh ke lalai AI8SAAT bila module tiada —
 *   pengguna diberi amaran dalam butang), dan koleksi lain yang dikunci ikut id module (system_templates /
 *   preset_fragments — GOYANG sahaja).
 */
import { collection, getDocs, deleteDoc, doc, getDoc } from 'firebase/firestore';
import { MODULES } from '../config/modules';

/** Sebab module TIDAK boleh dipadam, atau null bila boleh. */
export function sebabTakBolehPadam(modId, regModule) {
    if (!modId) return 'Tiada module dipilih.';
    if (MODULES[modId]) return 'Module asas sistem — tidak boleh dipadam.';
    if (!regModule || regModule.adminOnly !== true) return 'Module ini dibuka kepada pelanggan — tidak boleh dipadam dari sini.';
    return null;
}

/**
 * Padam module ujian admin. Melontar dengan mesej jelas bila gagal (pemanggil memaparkannya).
 * @returns { privateDipadam: number }
 */
export async function padamModule(db, modId, regModule) {
    const sebab = sebabTakBolehPadam(modId, regModule);
    if (sebab) throw new Error(sebab);
    // Semak semula di server — keadaan dalam ingatan boleh basi (cth akses diubah di tab lain).
    const snapUtama = await getDoc(doc(db, 'modules', modId));
    if (snapUtama.exists() && snapUtama.data()?.adminOnly !== true) {
        throw new Error('Module ini kini dibuka kepada pelanggan — tidak dipadam.');
    }
    const priv = await getDocs(collection(db, 'modules', modId, 'private'));
    for (const d of priv.docs) {
        await deleteDoc(doc(db, 'modules', modId, 'private', d.id));
    }
    await deleteDoc(doc(db, 'modules', modId));
    return { privateDipadam: priv.size };
}
